/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSymptoms } from 'app/entities/symptom/symptom.reducer';
import { getEntities as getSymptomAttributes } from 'app/entities/symptom-attribute/symptom-attribute.reducer';
import { createEntity, getEntity, reset, updateEntity } from './symptom-attribute-preference.reducer';

export const SymptomAttributePreferenceUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const symptoms = useAppSelector(state => state.symptom.entities);
  const symptomAttributes = useAppSelector(state => state.symptomAttribute.entities);
  const symptomAttributePreferenceEntity = useAppSelector(state => state.symptomAttributePreference.entity);
  const loading = useAppSelector(state => state.symptomAttributePreference.loading);
  const updating = useAppSelector(state => state.symptomAttributePreference.updating);
  const updateSuccess = useAppSelector(state => state.symptomAttributePreference.updateSuccess);

  const handleClose = () => {
    navigate(`/symptom-attribute-preference${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSymptoms({}));
    dispatch(getSymptomAttributes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.symptomOrder !== undefined && typeof values.symptomOrder !== 'number') {
      values.symptomOrder = Number(values.symptomOrder);
    }

    const entity = {
      ...symptomAttributePreferenceEntity,
      ...values,
      symptom: symptoms.find(it => it.id.toString() === values.symptom?.toString()),
      attribute: symptomAttributes.find(it => it.id.toString() === values.attribute?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...symptomAttributePreferenceEntity,
          symptom: symptomAttributePreferenceEntity?.symptom?.id,
          attribute: symptomAttributePreferenceEntity?.attribute?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.symptomAttributePreference.home.createOrEditLabel"
            data-cy="SymptomAttributePreferenceCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.home.createOrEditLabel">
              Create or edit a SymptomAttributePreference
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="symptom-attribute-preference-id"
                  label={translate('tinyMedicRestApp.symptomAttributePreference.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.symptomAttributePreference.active')}
                id="symptom-attribute-preference-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptomAttributePreference.cursor')}
                id="symptom-attribute-preference-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptomAttributePreference.lastUpdated')}
                id="symptom-attribute-preference-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptomAttributePreference.microSec')}
                id="symptom-attribute-preference-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptomAttributePreference.timestampEntry')}
                id="symptom-attribute-preference-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptomAttributePreference.symptomOrder')}
                id="symptom-attribute-preference-symptomOrder"
                name="symptomOrder"
                data-cy="symptomOrder"
                type="text"
              />
              <ValidatedField
                id="symptom-attribute-preference-symptom"
                name="symptom"
                data-cy="symptom"
                label={translate('tinyMedicRestApp.symptomAttributePreference.symptom')}
                type="select"
              >
                <option value="" key="0" />
                {symptoms
                  ? symptoms.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="symptom-attribute-preference-attribute"
                name="attribute"
                data-cy="attribute"
                label={translate('tinyMedicRestApp.symptomAttributePreference.attribute')}
                type="select"
              >
                <option value="" key="0" />
                {symptomAttributes
                  ? symptomAttributes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/symptom-attribute-preference"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SymptomAttributePreferenceUpdate;
